import { ChannelUsersService } from '@/backend/market'
import { ChannelUserRepository } from '../../domain/repositories/ChannelUserRepository'
import { ChannelUserModel } from '../models/ChannelUserModel'
import type { ChannelUserFilterEntity } from '../../domain/entities/ChannelUserFilterEntity'
import { ChannelUserFilterModel } from '../models/ChannelUserFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { ChannelUserEntity } from '../../domain/entities/ChannelUserEntity'
import type { CreateUpdateChannelUserEntity } from '../../domain/entities/CreateUpdateChannelUserEntity'
import { CreateUpdateChannelUserModel } from '../models/CreateUpdateChannelUserModel'

export class ChannelUserRepositoryImpl implements ChannelUserRepository {
  async getChannelUsers(
    filterData: ChannelUserFilterEntity
  ): Promise<PaginateEntity<ChannelUserEntity[]> | { error: true }> {
    const channelUserFilterModel = new ChannelUserFilterModel(filterData)
    try {
      const response = await ChannelUsersService.getChannelUsersAdmin(channelUserFilterModel)
      const channelUserModels = response.items?.map((item) => new ChannelUserModel(item))
      const channelUserResponse = new PaginateEntity<ChannelUserModel[]>(
        response,
        channelUserModels
      )

      return channelUserResponse
    } catch {
      return { error: true }
    }
  }
  async createChannelUser(
    channelUserData: CreateUpdateChannelUserEntity
  ): Promise<{ success: true } | { error: true }> {
    const channelUserModel = new CreateUpdateChannelUserModel(channelUserData)
    try {
      await ChannelUsersService.postChannelUserAdmin({
        requestBody: channelUserModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateChannelUser(
    id: number,
    channelUserData: CreateUpdateChannelUserEntity
  ): Promise<{ success: true } | { error: true }> {
    const channelUserModel = new CreateUpdateChannelUserModel(channelUserData)
    try {
      await ChannelUsersService.putChannelUserAdmin({
        id,
        requestBody: {
          channelIds: channelUserModel.channelIds ?? []
        }
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteChannelUser(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await ChannelUsersService.deleteChannelUserAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
